import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import AddProperty from './pages/AddProperty';
import PropertyList from './pages/PropertyList';
import PropertyDetail from './pages/PropertyDetail';
import PropertyLedger from './pages/PropertyLedger';
import RehabWorkflow from './pages/RehabWorkflow';
import LeadUnderwriting from './pages/LeadUnderwriting';
import UnderwritingCaseDetail from './pages/UnderwritingCaseDetail';
import Documents from './pages/Documents';
import StatementReview from './pages/StatementReview';
import Research from './pages/Research';
import ResearchBuyBox from './pages/ResearchBuyBox';
import ResearchDataWarehouseAudit from './pages/ResearchDataWarehouseAudit';
import ResearchMarketLanding from './pages/ResearchMarketLanding';
import ResearchMarketDetail from './pages/ResearchMarketDetail';
import RentCastApiLab from './pages/RentCastApiLab';
import TeamAccess from './pages/TeamAccess';
import ContractorDirectory from './pages/ContractorDirectory';
import { ActorProvider } from './app/ActorContext';
import ActorGate from './app/ActorGate';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ActorProvider>
                <ActorGate>
                  <div className="app">
                    <Navbar />
                    <div className="app-content">
                      <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/properties" element={<PropertyList />} />
                    <Route path="/properties/:id" element={<PropertyDetail />} />
                    <Route path="/add-property" element={<AddProperty />} />
                    <Route path="/properties/:id/ledger" element={<PropertyLedger />} />
                    <Route path="/properties/:id/rehab" element={<RehabWorkflow />} />
                    <Route path="/research" element={<Research />} />
                    <Route path="/research/brrrr-buy-box" element={<ResearchBuyBox />} />
                    <Route path="/research/data-warehouse-audit" element={<ResearchDataWarehouseAudit />} />
                    <Route path="/research/markets" element={<ResearchMarketLanding />} />
                    <Route path="/research/markets/:regionSlug" element={<ResearchMarketDetail />} />
                    <Route path="/research/api-lab" element={<RentCastApiLab />} />
                    <Route path="/research/rentcast-api-lab" element={<Navigate to="/research/api-lab" replace />} />
                    <Route path="/lead-underwriting" element={<LeadUnderwriting />} />
                    <Route path="/lead-underwriting/new" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/lead-underwriting/:id" element={<UnderwritingCaseDetail />} />
                    <Route path="/lead-underwriting/:id/edit" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/deals" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/deals/:id" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/deals/:id/edit" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/add-deal" element={<Navigate to="/lead-underwriting" replace />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/team" element={<TeamAccess />} />
                    <Route path="/contractors" element={<ContractorDirectory />} />
                    <Route path="/properties/:id/statements" element={<StatementReview />} />
                      </Routes>
                    </div>
                  </div>
                </ActorGate>
              </ActorProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
